// extracted by mini-css-extract-plugin
module.exports = {"layout":"agenda_layout__s8XYC","day":"agenda_day__UCpGg","divider":"agenda_divider__PGfJt","pinned":"agenda_pinned___QGLf","timeslot":"agenda_timeslot__IxtP6"};